import gsap from 'gsap';

const selectors = {
  el: '.js-mouse-images:not(.is-initialized)',
  image: '.js-mouse-images-item',
};

const classes = {
  active: 'is-active',
};

const init = () => {
  const els = document.querySelectorAll(selectors.el);
  els.forEach(el => {
    el.classList.add('is-initialized');

    const images = el.querySelectorAll(selectors.image);
    let i = 0;
    let prevX = 0;

    const animateImages = () => {
      if (document.documentElement.dataset.whatintent !== 'mouse') return;
      images.forEach((image, i) => {
        setTimeout(() => {
          image.classList.add(classes.active);

          gsap.set(image, {
            '--x': `calc(50% + ${i * 20}px)`,
            '--y': `calc(50% + ${i * -20}px)`,
          });

          setTimeout(() => {
              image.classList.remove(classes.active);
            }, 800);
        }, i * 100);
      });
    };

    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        start: 'top top',
        onEnter: animateImages,
        onEnterBack: animateImages,
      },
    });

    el.addEventListener('mousemove', e => {
      if (Math.abs(e.clientX - prevX) > 100) {
        const activeImage = images[i];
        activeImage.classList.add(classes.active);

        const targetX = e.clientX - el.getBoundingClientRect().left + 'px';
        const targetY = e.clientY - el.getBoundingClientRect().top + 'px';
        gsap.set(activeImage, {
          '--x': targetX,
          '--y': targetY,
        });
        setTimeout(() => {
          activeImage.classList.remove(classes.active);
        }, 800);

        if (i < images.length - 1) {
          i++;
        } else {
          i = 0;
        }
        prevX = e.clientX;
      }
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
